import { render, staticRenderFns } from "./PrivateLabels.vue?vue&type=template&id=a3edb6da&scoped=true&"
import script from "./PrivateLabels.vue?vue&type=script&lang=js&"
export * from "./PrivateLabels.vue?vue&type=script&lang=js&"
import style0 from "./PrivateLabels.vue?vue&type=style&index=0&id=a3edb6da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3edb6da",
  null
  
)

export default component.exports